import { m } from 'framer-motion';
import { Stack, Typography } from '@mui/material';
import { GRAPH_WIDTH } from './constants';

type HighestScoringTestBubbleProps = {
  bottom: number;
  date: string;
  score: string;
};

export const HighestScoringTestBubble = ({
  bottom,
  date,
  score,
}: HighestScoringTestBubbleProps) => (
  <m.div initial={{ scale: 0 }} animate={{ scale: 1 }}>
    <Stack
      alignItems="center"
      bgcolor="white"
      border="2px solid black"
      borderRadius="32px"
      bottom={bottom}
      boxShadow="2px 4px 4px 0px #0000001F"
      height="64px"
      justifyContent="center"
      left={GRAPH_WIDTH / 2}
      position="absolute"
      width="64px"
      sx={{ transform: 'translate(-50%, 50%)' }}
    >
      <Stack alignItems="center" height="53px">
        <Typography fontSize="16px" letterSpacing="0.46px" lineHeight="26px">
          <strong>{score}</strong>
        </Typography>
        <Typography color="text.secondary" fontSize="12px" letterSpacing="0.46px" lineHeight="11px">
          {date}
        </Typography>
      </Stack>
    </Stack>
  </m.div>
);
